//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Flexbox, FlexboxItem } from '../flexbox'
import { Swiper, SwiperItem } from '../swiper'
import dateFormat from '../../tools/date/format'
import calendarMarksMixin from '../../mixins/calendar-marks'

/**
import { Flexbox, FlexboxItem, Swiper, SwiperItem, dateFormat } from 'vux'
**/

const getNextIndex = (index) => {
  if (index === 2) {
    return 0
  }
  if (index === 0) {
    return 1
  }
  return 2
}

const getPrevIndex = index => {
  if (index === 2) {
    return 1
  }
  if (index === 1) {
    return 0
  }
  if (index === 0) {
    return 2
  }
}

const indexMap = {
  0: 'last',
  1: 'current',
  2: 'next'
}

export default {
  mixins: [calendarMarksMixin],
  components: {
    Swiper,
    SwiperItem,
    Flexbox,
    FlexboxItem
  },
  props: {
    value: String,
    height: {
      type: String,
      default: '65px'
    },
    marks: {
      type: Array,
      default () {
        return []
      }
    }
  },
  created () {
    [0, 7, -7].forEach(item => {
      this.getThisWeekRange(item)
    })
  },
  mounted () {
    this.index = 1
  },
  watch: {
    value (val) {
      this.currentValue = val
      this.changeData(null, this.index, val)
    },
    currentValue (val) {
      this.$emit('input', val)
      this.$emit('on-change', val)
    },
    currentMonth (val) {
      const value = this.currentMonth.split('-')
      const data = {
        year: value[0],
        month: value[1]
      }
      this.$emit('on-year-month-change', data)
    }
  },
  data () {
    return {
      currentValue: this.value,
      index: 0,
      lastWeekList: [],
      currentWeekList: [],
      nextWeekList: [],
      startDate: dateFormat(new Date(), 'YYYY-MM-DD'),
      currentMonth: '',
      changeCount: -1,
      hasRender: false
    }
  },
  methods: {
    switchViewToCurrentValue () {
      if (this.currentValue) {
        this.changeData(null, this.index, this.currentValue)
      }
    },
    switchViewToMonth (year, month) {
      this.changeData(null, this.index, `${year}-${month}-01`)
    },
    switchViewToToday () {
      const today = dateFormat(new Date(), 'YYYY-MM-DD')
      this.changeData(null, this.index, today)
    },
    onClick (i) {
      this.currentValue = i.format
    },
    onIndexChange (newIndex) {
      let el = document.querySelector('#x000' + newIndex)
      const start = el.getAttribute('data-start')
      const date = new Date(start)
      this.changeData(date, newIndex)
    },
    changeData (date, index, value) {
      // if has value, reset start
      if (value) {
        const _date = new Date(value.replace(/-/g, '/'))
        date = new Date(_date.setDate(_date.getDate() - _date.getDay()))
        this[indexMap[index] + 'WeekList'] = this.getWeekRange(new Date(date.setDate(date.getDate())))
      }

      this.startDate = dateFormat(date, 'YYYY-MM-DD')

      const lastMonth = dateFormat(date.getTime() + 6 * 24 * 3600 * 1000, 'YYYY-MM')
      this.currentMonth = lastMonth

      const nextIndex = getNextIndex(index)
      const nextKey = indexMap[nextIndex]
      this[nextKey + 'WeekList'] = this.getWeekRange(new Date(date.setDate(date.getDate() + 7)))
      const lastIndex = getPrevIndex(index)
      const lastKey = indexMap[lastIndex]
      this[lastKey + 'WeekList'] = this.getWeekRange(new Date(date.setDate(date.getDate() - 14)))

      this.$nextTick(() => {
        this.changeCount++
        this.$emit('on-view-change', {
          allDates: this[indexMap[this.index] + 'WeekList']
        }, this.changeCount)
      })
    },
    getCurrentDates () {
      return this[indexMap[this.index] + 'WeekList']
    },
    getCurrentYearMonth () {
      const value = this.currentMonth.split('-')
      return {
        year: value[0],
        month: value[1]
      }
    },
    isToday (date) {
      return dateFormat(date, 'YYYY-MM-DD') === dateFormat(new Date(), 'YYYY-MM-DD')
    },
    isSelected (date) {
      return dateFormat(date, 'YYYY-MM-DD') === this.date
    },
    isWeekend (date) {
      return date.getDay() === 0 || date.getDay() === 6
    },
    getWeekRange (start) {
      let rs = [{
        format: dateFormat(start, 'YYYY-MM-DD'),
        formatedDate: dateFormat(start, 'YYYY-MM-DD'),
        date: start,
        str: dateFormat(start, 'D'),
        isWeekend: this.isWeekend(start),
        isToday: this.isWeekend(start),
        isSelected: this.isSelected(start),
        _date: start.getDate()
      }]
      for (let i = 1; i < 7; i++) {
        let current = start
        current.setDate(current.getDate() + 1)
        rs.push({
          format: dateFormat(current, 'YYYY-MM-DD'),
          date: current,
          str: dateFormat(current, 'D'),
          formatedDate: dateFormat(current, 'YYYY-MM-DD'),
          isWeekend: this.isWeekend(current),
          isToday: this.isToday(current),
          isSelected: this.isSelected(current),
          _date: current.getDate()
        })
      }
      return rs
    },
    getThisWeekRange (day = 0, start) {
      const now = start || new Date()
      const firstday = new Date(now.setDate(now.getDate() - now.getDay() + day))
      if (day === 0) {
        this.currentWeekList = this.getWeekRange(firstday)
      }
      if (day === 7) {
        this.nextWeekList = this.getWeekRange(firstday)
      }
      if (day === -7) {
        this.lastWeekList = this.getWeekRange(firstday)
      }
    }
  }
}
